var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 52 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M26 57C40.3594 57 52 45.6116 52 31.5632C52 17.5149 40.3594 6.12646 26 6.12646C11.6406 6.12646 0 17.5149 0 31.5632C0 45.6116 11.6406 57 26 57Z",
    fill: "url(#paint0_radial_4655_315439)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8473 7.74985C17.8473 7.74985 21.1829 6.47573 22.3523 10.5191H26.7576V0.0141602C26.7576 0.0141602 19.9204 1.11276 17.8407 7.74985H17.8473Z",
    fill: "url(#paint1_linear_4655_315439)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7635 0.0141602V10.5191H31.1688C32.3449 6.47573 35.6738 7.74985 35.6738 7.74985C33.6007 1.11276 26.7635 0.0141602 26.7635 0.0141602Z",
    fill: "url(#paint2_linear_4655_315439)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7433 52.0477C33.7433 52.0477 42.9792 49.1549 47.4044 39.105L46.2217 37.6034C46.2217 37.6034 50.4742 29.8677 49.5905 21.0334C49.5905 21.0334 46.7001 22.5871 44.926 19.8763C43.1586 17.1656 35.6503 10.8145 26.6802 9.77441L26.7533 16.2165C26.7533 16.2165 39.3978 15.1569 42.7267 29.0096C46.0556 42.8624 35.2516 48.7129 35.2516 48.7129L33.7433 52.0477Z",
    fill: "url(#paint3_linear_4655_315439)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9252 19.8799C44.9252 19.8799 47.4899 21.128 49.5896 21.037C49.5896 21.037 48.9252 22.7401 48.0747 24.1833C47.6361 24.9243 46.1145 27.9081 46.1145 27.9081C46.1145 27.9081 46.759 23.7802 46.7325 22.8571C46.7059 21.9341 44.9318 19.8864 44.9318 19.8864L44.9252 19.8799Z",
    fill: "#1855B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2955 40.4268L46.2955 37.4691L46.9135 36.1689L47.4051 39.1072C47.4051 39.1072 46.3154 38.6457 46.1095 38.6457C45.9035 38.6457 44.2955 40.4268 44.2955 40.4268Z",
    fill: "#1A499C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9258 19.8774C44.9258 19.8774 42.6733 15.8146 38.2281 10.5621C33.8493 5.38113 26.7464 9.76902 26.7464 9.76902L32.0022 10.8676C32.0022 10.8676 34.939 10.5946 37.949 12.4538C40.1151 13.7994 41.6832 16.4971 41.6832 16.4971L44.9258 19.8774Z",
    fill: "url(#paint4_linear_4655_315439)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5312 10.8141C31.5312 10.8141 35.3385 9.81949 38.0361 11.8087C40.7338 13.7978 41.9763 16.7036 41.9763 16.7036C41.9763 16.7036 40.076 14.2789 31.5312 10.8141Z",
    fill: "#0B0B20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4243 9.41481C27.4243 9.41481 29.4044 10.3769 31.5306 10.5719C33.6569 10.7604 35.1585 10.0519 36.8794 11.157C36.8794 11.157 36.6668 9.11578 34.2416 8.33571C31.823 7.55564 27.4176 9.41481 27.4176 9.41481H27.4243Z",
    fill: "#1F4448"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6671 20.5531C47.6771 20.8262 50.4744 18.4925 51.0658 18.7265C51.6571 18.9605 50.0359 27.6518 48.0757 33.1448C48.0757 33.1448 49.8564 25.9161 49.5907 21.0342C49.5907 21.0342 48.2153 21.1382 46.6671 20.5531Z",
    fill: "url(#paint5_linear_4655_315439)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1715 18.9927C51.1715 18.9927 50.4406 19.7922 50.002 21.2094C49.5635 22.62 49.0784 29.2181 48.0685 33.1509C48.0685 33.1509 51.1117 24.1021 51.1715 18.9992V18.9927Z",
    fill: "#0B0B20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9119 36.1689C46.9119 36.1689 49.3239 36.1949 49.5897 37.3195C49.8555 38.4441 43.0382 45.7703 43.0382 45.7703C43.0382 45.7703 46.4136 41.4604 47.4036 39.1072L46.9119 36.1689Z",
    fill: "url(#paint6_linear_4655_315439)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0382 45.7706C43.0382 45.7706 46.9651 40.4336 47.4036 39.426C47.8488 38.4184 49.5897 37.3198 49.5897 37.3198C49.5897 37.3198 49.7026 38.0674 47.4036 40.7716C45.1046 43.4759 43.0382 45.7706 43.0382 45.7706Z",
    fill: "#0B0B20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9071 19.3402C51.0268 18.8786 49.7111 20.5883 49.5915 20.6598C49.4719 20.7313 49.6248 22.2589 49.6248 22.2589C49.6248 22.2589 50.7477 19.9577 50.9071 19.3402Z",
    fill: "#2E5155"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6912 38.9557C47.6912 38.9557 47.8972 38.1691 48.3091 37.8116C48.7211 37.4541 49.4055 37.4346 49.4055 37.4346C49.4055 37.4346 48.4686 38.5592 47.6912 38.9557Z",
    fill: "#2E5155"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1276 27.7869C46.1276 27.7869 46.8452 25.0436 47.2572 24.2116C47.6691 23.373 49.3037 21.7153 49.3037 21.7153C49.3037 21.7153 48.2406 24.4391 46.121 27.7869H46.1276Z",
    fill: "#44C3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4854 49.7875C35.4854 49.7875 38.8077 49.0399 42.316 44.3335C45.8243 39.6271 46.1299 33.9976 46.1299 33.9976C46.1299 33.9976 44.0502 44.0215 36.2562 48.7799L35.4854 49.7875Z",
    fill: "#4E2574"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4484 10.5182C34.4484 10.5182 34.9799 10.1217 35.5979 10.0957C36.2158 10.0697 36.8736 11.1553 36.8736 11.1553C36.8736 11.1553 35.0663 10.7132 34.4417 10.5182H34.4484Z",
    fill: "#2E5155"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6797 52.0477C19.6797 52.0477 10.4439 49.1549 6.0186 39.105L7.20133 37.6034C7.20133 37.6034 2.94884 29.8677 3.83256 21.0334C3.83256 21.0334 6.72292 22.5871 8.49701 19.8763C10.2645 17.1656 17.7063 10.8145 26.6764 9.77441V16.2165C26.6764 16.2165 14.0319 15.1569 10.703 29.0096C7.37409 42.8624 18.1781 48.7129 18.1781 48.7129L19.6864 52.0477H19.6797Z",
    fill: "url(#paint7_linear_4655_315439)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49621 19.8799C8.49621 19.8799 5.93142 21.128 3.83176 21.037C3.83176 21.037 4.49621 22.7401 5.34671 24.1833C5.78524 24.9243 7.30684 27.9081 7.30684 27.9081C7.30684 27.9081 6.66232 23.7802 6.6889 22.8571C6.71548 21.9341 8.48956 19.8864 8.48956 19.8864L8.49621 19.8799Z",
    fill: "#1855B7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13658 40.4268L7.13658 37.4691L6.51864 36.1689L6.02695 39.1072C6.02695 39.1072 7.11665 38.6457 7.32263 38.6457C7.52861 38.6457 9.13658 40.4268 9.13658 40.4268Z",
    fill: "#1A499C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49649 19.8774C8.49649 19.8774 10.749 15.8146 15.1942 10.5621C19.5729 5.38113 26.6759 9.76902 26.6759 9.76902L21.4201 10.8676C21.4201 10.8676 18.4832 10.5946 15.4732 12.4538C13.3071 13.7994 11.739 16.4971 11.739 16.4971L8.49649 19.8774Z",
    fill: "url(#paint8_linear_4655_315439)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8914 10.8141C21.8914 10.8141 18.0841 9.81949 15.3865 11.8087C12.6888 13.7978 11.4463 16.7036 11.4463 16.7036C11.4463 16.7036 13.3466 14.2789 21.8914 10.8141Z",
    fill: "#0B0B20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 9.41481C25.9998 9.41481 24.0198 10.3769 21.8935 10.5719C19.7673 10.7604 18.2656 10.0519 16.5447 11.157C16.5447 11.157 16.7573 9.11578 19.1826 8.33571C21.6012 7.55564 26.0065 9.41481 26.0065 9.41481H25.9998Z",
    fill: "#1F4448"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75649 20.5531C5.74652 20.8262 2.94918 18.4925 2.35781 18.7265C1.76645 18.9605 3.38771 27.6518 5.34785 33.1448C5.34785 33.1448 3.56712 25.9161 3.8329 21.0342C3.8329 21.0342 5.20831 21.1382 6.75649 20.5531Z",
    fill: "url(#paint9_linear_4655_315439)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25153 18.9927C2.25153 18.9927 2.98242 19.7922 3.42096 21.2094C3.8595 22.62 4.34455 29.2181 5.35452 33.1509C5.35452 33.1509 2.31133 24.1021 2.25153 18.9992V18.9927Z",
    fill: "#0B0B20"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50972 36.1689C6.50972 36.1689 4.09776 36.1949 3.83198 37.3195C3.5662 38.4441 10.3835 45.7703 10.3835 45.7703C10.3835 45.7703 7.00806 41.4604 6.01802 39.1072L6.50972 36.1689Z",
    fill: "url(#paint10_linear_4655_315439)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3844 45.7706C10.3844 45.7706 6.45752 40.4336 6.01898 39.426C5.5738 38.4184 3.83294 37.3198 3.83294 37.3198C3.83294 37.3198 3.71998 38.0674 6.01898 40.7716C8.31799 43.4759 10.3844 45.7706 10.3844 45.7706Z",
    fill: "#0B0B20"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52379 19.3402C2.40419 18.8786 3.7198 20.5883 3.83941 20.6598C3.95901 20.7313 3.80618 22.2589 3.80618 22.2589C3.80618 22.2589 2.68326 19.9577 2.52379 19.3402Z",
    fill: "#2E5155"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73281 38.9557C5.73281 38.9557 5.52683 38.1691 5.11487 37.8116C4.70291 37.4541 4.01852 37.4346 4.01852 37.4346C4.01852 37.4346 4.9554 38.5592 5.73281 38.9557Z",
    fill: "#2E5155"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29449 27.7874C7.29449 27.7874 6.57688 25.0441 6.16492 24.212C5.75296 23.3735 4.11841 21.7158 4.11841 21.7158C4.11841 21.7158 5.18153 24.4396 7.30113 27.7874H7.29449Z",
    fill: "#44C3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3733 49.3779C17.3733 49.3779 14.5295 48.8059 11.0145 44.0995C7.49956 39.393 7.29358 33.9976 7.29358 33.9976C7.29358 33.9976 9.37331 44.0215 17.1673 48.7799L17.3733 49.3779Z",
    fill: "#4E2574"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9773 10.5187C18.9773 10.5187 18.4457 10.1222 17.8277 10.0962C17.2098 10.0702 16.552 11.1558 16.552 11.1558C16.552 11.1558 18.3593 10.7137 18.9839 10.5187H18.9773Z",
    fill: "#2E5155"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7515 13.1016C15.994 13.1016 7.27643 21.6303 7.27643 32.1483C7.27643 42.6662 15.994 51.2014 26.7515 51.2014C37.509 51.2014 46.2199 42.6727 46.2199 32.1483C46.2199 21.6238 37.5023 13.1016 26.7515 13.1016ZM26.7515 46.7616C18.499 46.7616 11.8146 40.222 11.8146 32.1483C11.8146 24.0745 18.499 17.5415 26.7515 17.5415C35.004 17.5415 41.6817 24.081 41.6817 32.1483C41.6817 40.2155 34.9974 46.7616 26.7515 46.7616Z",
    fill: "url(#paint11_linear_4655_315439)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7495 11.152C18.1913 11.152 10.796 16.0534 7.34747 23.1456L7.4405 23.0676L11.8724 30.8358C12.5501 23.3861 18.9488 17.5356 26.7495 17.5356C34.5501 17.5356 40.9887 23.4251 41.6332 30.9138L46.1116 23.0611C42.6498 16.0079 35.281 11.1455 26.7561 11.1455L26.7495 11.152Z",
    fill: "url(#paint12_linear_4655_315439)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7513 16.2173C17.7546 16.2173 10.4589 23.3549 10.4589 32.1502C10.4589 40.9455 17.7546 48.0896 26.7513 48.0896C35.748 48.0896 43.037 40.952 43.037 32.1502C43.037 23.3484 35.7413 16.2173 26.7513 16.2173ZM26.7513 46.7635C18.4988 46.7635 11.8144 40.2239 11.8144 32.1502C11.8144 24.0765 18.4988 17.5434 26.7513 17.5434C35.0038 17.5434 41.6815 24.083 41.6815 32.1502C41.6815 40.2174 34.9971 46.7635 26.7513 46.7635Z",
    fill: "url(#paint13_linear_4655_315439)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1064 23.0679L45.5882 27.3192L45.2892 26.3312L42.7177 29.0094L46.1064 23.0679Z",
    fill: "#0B0B20"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44302 23.0679L7.95465 27.1502L8.2005 26.3377L10.7919 28.9379L7.44302 23.0679Z",
    fill: "#0B0B20"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.726 48.4827L20.7127 46.9551H32.7857L36.2542 48.7752L32.7658 53.3061H20.2542L16.726 48.4827Z",
    fill: "url(#paint14_linear_4655_315439)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7256 48.4853L19.8619 46.6001L20.7655 45.5405H32.7323L33.4433 46.7626L36.121 48.7128L32.7854 46.9577H20.7124L16.7256 48.4853Z",
    fill: "#3B5E61"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7521 49.0717C18.7521 49.0717 20.9182 47.6025 26.493 47.6025C32.0677 47.6025 34.473 49.4097 34.473 49.4097C34.473 49.4097 33.1175 51.8929 31.8551 52.491C30.5926 53.0955 22.0611 52.803 21.2172 52.582C20.3734 52.361 18.7521 49.0717 18.7521 49.0717Z",
    fill: "url(#paint15_linear_4655_315439)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3303 49.1324C19.3303 49.1324 21.3369 47.7607 26.4997 47.7607C31.6625 47.7607 33.8951 49.4444 33.8951 49.4444C33.8951 49.4444 32.6393 51.7586 31.4698 52.3241C30.3004 52.8832 22.3934 52.6167 21.616 52.4087C20.8386 52.2006 19.3303 49.1324 19.3303 49.1324Z",
    fill: "#0B0B20"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4845 46.9613C26.1456 46.8247 28.3582 45.9992 30.4645 45.9147C32.5642 45.8302 32.7835 46.9613 32.7835 46.9613H26.4845Z",
    fill: "#4C6C70"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5266 35.5769C41.9817 35.5184 41.4568 36.6495 41.9884 37.3971C42.5133 38.1381 43.7691 35.7069 42.5266 35.5769Z",
    fill: "#0B0B20"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8553 36.4343C41.9284 37.0389 42.7058 36.9284 42.9384 36.5644C43.1776 36.1938 43.0248 35.4918 42.4533 35.5828C41.8753 35.6803 41.8553 36.4343 41.8553 36.4343Z",
    fill: "#BE1FB2"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8014 36.983C41.9011 36.5929 42.4393 36.944 42.7184 36.9114C42.9975 36.8789 42.6386 37.555 42.2998 37.529C41.9609 37.503 41.8014 36.9765 41.8014 36.9765V36.983Z",
    fill: "#3B5E61"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5485 10.8234C37.0768 11.0964 37.3425 12.3055 38.2263 12.5981C39.0967 12.8841 38.6249 10.1994 37.5485 10.8234Z",
    fill: "#0B0B20"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5282 11.8959C37.9535 12.3445 38.5116 11.7984 38.4784 11.3694C38.4452 10.9338 37.8937 10.4528 37.4883 10.8688C37.083 11.2784 37.5282 11.9024 37.5282 11.9024V11.8959Z",
    fill: "#BE1FB2"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8157 12.3711C37.6562 12.0006 38.3074 11.968 38.5134 11.7795C38.7194 11.591 38.839 12.3451 38.5533 12.5206C38.2675 12.6961 37.8157 12.3711 37.8157 12.3711Z",
    fill: "#3B5E61"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4422 18.8926C17.0569 18.509 15.9206 19.0486 15.8409 19.9587C15.7612 20.8558 18.3127 19.7702 17.4422 18.8926Z",
    fill: "#0B0B20"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3725 19.1279C16.027 19.6414 16.7047 20.0445 17.1233 19.9079C17.5486 19.7714 17.8941 19.1344 17.3891 18.8483C16.8841 18.5623 16.3725 19.1279 16.3725 19.1279Z",
    fill: "#BE1FB2"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9732 19.5183C16.3054 19.2778 16.4848 19.8889 16.724 20.0384C16.9632 20.1879 16.239 20.4869 15.9998 20.2529C15.7539 20.0254 15.9732 19.5183 15.9732 19.5183Z",
    fill: "#3B5E61"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80894 22.2626C7.60296 22.6461 9.21758 25.6689 9.88203 26.6244C10.5465 27.58 14.0282 18.0372 23.0448 16.6331C32.0614 15.2354 36.7259 19.3763 37.5099 19.8833C38.3006 20.3904 39.9285 16.061 39.6428 15.3654C39.3571 14.6699 32.593 10.373 23.2109 11.4391C13.8222 12.5052 7.80894 22.2626 7.80894 22.2626Z",
    fill: "#84A1A4"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7306 12.0229C26.7306 12.0229 21.1957 12.075 16.3585 15.1562C16.3585 15.1562 18.3651 16.9764 18.7438 17.0999C19.1226 17.2234 22.1591 15.3577 26.7306 15.3577C31.7339 15.3577 34.3319 17.2234 34.7173 17.0999C35.1026 16.9764 37.1026 15.1562 37.1026 15.1562C32.2654 12.075 26.7372 12.0229 26.7306 12.0229Z",
    fill: "url(#paint16_linear_4655_315439)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9578 16.7301L17.1572 14.9684C17.1572 14.9684 21.4894 12.3682 26.7253 12.3682C31.9611 12.3682 36.1937 15.1374 36.1937 15.1374L34.5791 16.7236C34.5791 16.7236 31.2967 15.0269 26.8781 15.0269C22.4595 15.0269 18.9578 16.7236 18.9578 16.7236V16.7301Z",
    fill: "#121632"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1171 17.0338C19.1171 17.0338 21.2833 15.0381 26.8846 15.0381C32.4859 15.0381 34.373 17.0338 34.373 17.0338C34.373 17.0338 31.9809 15.3696 26.7318 15.3696C21.4826 15.3696 19.1171 17.0338 19.1171 17.0338Z",
    fill: "#4C6C70"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3585 15.1578H17.3551C17.3551 15.1578 20.6109 12.5121 26.684 12.5121C32.7571 12.5121 36.2056 15.3399 36.2056 15.3399L37.1093 15.1513C37.1093 15.1513 33.7139 12.0181 26.7372 12.0181C19.7605 12.0181 16.3651 15.1513 16.3651 15.1513L16.3585 15.1578Z",
    fill: "#4E2574"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7585 40.3067C44.7585 40.3067 45.9479 39.2666 46.1074 38.6426C46.1074 38.6426 45.4429 39.0521 45.1771 39.4747C44.9114 39.8972 44.7585 40.3067 44.7585 40.3067Z",
    fill: "#44C3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49934 27.5308C8.49934 27.5308 10.2734 29.0909 10.3864 29.5654C10.4993 30.04 9.76844 35.7215 13.1239 40.896C16.4794 46.0704 12.001 44.5948 11.8083 44.3738C11.6223 44.1527 4.49934 35.4095 8.49269 27.5308H8.49934Z",
    fill: "#84A1A4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9979 27.9053C10.9979 27.9053 16.3933 17.5434 26.7454 17.5434C37.0976 17.5434 42.4066 28.1783 42.4066 28.1783C42.4066 28.1783 39.3235 16.2173 26.7454 16.2173C14.1674 16.2173 10.9979 27.9053 10.9979 27.9053Z",
    fill: "#4E2574"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8929 46.4782C33.8929 46.4782 38.9893 42.9094 41.2152 39.4771C41.2152 39.4771 38.9427 44.4435 33.8929 46.4782Z",
    fill: "#4C6C70"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.624 42.7988C14.624 42.7988 17.4213 45.3016 19.8599 46.6017C19.8599 46.6017 17.2419 45.7761 14.624 42.7988Z",
    fill: "#4C6C70"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59695 43.2974C8.59695 43.2974 10.9757 45.371 14.1185 47.4707C17.2614 49.5704 19.1617 51.8196 19.1617 51.8196C19.1617 51.8196 12.185 49.4534 8.59695 43.2974Z",
    fill: "#71FF9C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M33.741 52.0471C33.741 52.0471 36.1331 50.1165 38.658 48.0883C41.1762 46.0601 44.7643 43.2974 44.7643 43.2974C44.7643 43.2974 41.4154 49.2519 33.7477 52.0471H33.741Z",
    fill: "#71FF9C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4347 38.6453C45.4347 38.6453 46.252 33.4514 46.458 32.7558C46.664 32.0603 48.5444 30.4741 48.5444 30.4741C48.5444 30.4741 48.2454 34.6605 45.4347 38.6453Z",
    fill: "#00FF4D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59805 39.4763C8.59805 39.4763 6.44523 37.0841 5.35553 31.9941C5.35553 31.9941 6.97015 32.2542 7.29573 34.0028C7.62131 35.7515 8.59805 39.4828 8.59805 39.4828V39.4763Z",
    fill: "#00FF4D"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3871 16.549C12.3871 16.549 18.6661 11.394 26.7525 11.394C34.8389 11.394 41.1179 16.549 41.1179 16.549C41.1179 16.549 35.4635 10.9585 26.6794 10.9585C17.8954 10.9585 12.3871 16.549 12.3871 16.549Z",
    fill: "#4C6C70"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3118 31.1697C46.3118 31.1697 46.8367 29.3495 47.4015 28.6279C47.4015 28.6279 48.4115 30.8771 46.3118 31.1697Z",
    fill: "#00FF4D"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7804 6.24623C19.7804 6.24623 22.4847 1.27979 26.7239 1.27979C30.9631 1.27979 33.5013 6.24623 33.5013 6.24623C33.5013 6.24623 28.3252 9.01547 26.6375 9.01547C24.9498 9.01547 19.7737 6.24623 19.7737 6.24623H19.7804Z",
    fill: "url(#paint17_linear_4655_315439)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7855 5.8496C20.6128 5.47907 23.5297 1.86475 26.7457 1.86475C29.9616 1.86475 32.739 5.21254 32.6792 5.8496C32.6194 6.48666 29.0845 8.30032 26.646 8.30032C24.2074 8.30032 21.0978 6.51266 20.7855 5.8496Z",
    fill: "url(#paint18_linear_4655_315439)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3046 11.1526C22.3046 11.1526 24.1251 10.0345 26.763 10.093C29.4009 10.1515 31.9923 11.3932 31.9923 11.3932C31.9923 11.3932 26.2315 10.7756 22.3046 11.1526Z",
    fill: "#00FF4D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9067 7.438C21.7273 6.3134 25.0362 4.85727 28.7505 5.59184C32.4648 6.3264 28.4648 7.94505 26.9366 8.04255C25.4083 8.14006 23.9067 7.4445 23.9067 7.4445V7.438Z",
    fill: "#00FF4D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3323 5.38815C20.3323 5.38815 23.5815 2.30038 26.7443 2.30038C29.9071 2.30038 32.6778 5.71968 32.6778 5.71968L33.2958 5.87569C33.2958 5.87569 30.6513 1.27979 26.7243 1.27979C22.7974 1.27979 20.3323 5.38165 20.3323 5.38165V5.38815Z",
    fill: "#4E2574"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0729 7.10301C18.0729 7.10301 19.734 6.30994 19.9267 6.00441C20.1194 5.69888 22.0796 1.63602 26.7241 1.13548C26.7241 1.13548 26.9101 0.17339 26.7573 0.0173765C26.6045 -0.138637 21.3885 0.641433 18.0663 7.10301H18.0729Z",
    fill: "#2E5155"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7635 9.56129C26.7635 9.56129 29.4745 8.39119 30.6572 7.66312C31.8399 6.94156 33.4346 6.37601 33.9196 6.42151C34.4047 6.46701 35.6804 7.75413 35.6804 7.75413C35.6804 7.75413 33.9861 7.09107 32.4113 8.19617C32.4113 8.19617 31.1422 8.15066 26.7635 9.56129Z",
    fill: "#0B0B20"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8033 0.110352C26.7037 0.110352 25.4678 1.31946 25.408 1.39097C25.3482 1.46247 26.8233 1.31296 26.9229 1.29346C27.0226 1.28046 26.8033 0.110352 26.8033 0.110352Z",
    fill: "#35585C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1461 6.95036C32.1461 6.95036 32.6511 6.04028 32.8504 5.93627C33.0564 5.82576 33.4484 6.18979 33.5016 6.25479C33.5481 6.3263 33.4019 6.3718 32.1461 6.95036Z",
    fill: "#35585C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1679 3.28097C27.8356 3.39798 28.8788 4.58109 29.3174 4.45108C29.7626 4.32106 29.138 2.93644 28.1679 3.28097Z",
    fill: "#71FF9C"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3797 7.61953C18.3797 7.61953 20.094 6.70295 20.9777 6.94997C21.8614 7.197 25.7285 9.23168 25.7285 9.23168C25.7285 9.23168 23.3432 8.3281 20.7784 7.99007C20.7784 7.99007 19.9279 7.35951 18.3797 7.61953Z",
    fill: "#0B0B20"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4357 52.3193C21.4357 52.3193 21.1034 52.6704 25.4888 52.9889C29.8676 53.3074 31.4689 52.3258 31.4689 52.3258C31.4689 52.3258 26.5719 53.0799 21.4357 52.3258V52.3193Z",
    fill: "#4C6C70"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M49.2416 33.8474C48.7897 36.1551 47.4077 37.8323 46.1585 37.5918C44.9093 37.3577 44.2648 35.2971 44.7166 32.9893C45.1685 30.6816 46.5505 29.011 47.7997 29.245C49.0489 29.479 49.6934 31.5397 49.2416 33.8474Z",
    fill: "url(#paint19_radial_4655_315439)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M9.19494 34.4473C9.83282 36.7095 9.35441 38.8157 8.13182 39.1408C6.90258 39.4723 5.39428 37.9056 4.7564 35.6434C4.11853 33.3812 4.59693 31.2751 5.81953 30.95C7.04876 30.6185 8.55707 32.1851 9.19494 34.4473Z",
    fill: "url(#paint20_radial_4655_315439)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M15.3946 46.5943C17.2019 48.1349 17.9926 50.1436 17.1554 51.0862C16.3182 52.0288 14.172 51.5412 12.3647 50.0006C10.5574 48.46 9.76666 46.4513 10.6039 45.5087C11.4411 44.5661 13.5873 45.0537 15.3946 46.5943Z",
    fill: "url(#paint21_radial_4655_315439)"
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5034 26.4287L27.5156 38.4122H25.2448L21.2385 26.4287H23.6755L25.5771 32.4557L26.4448 35.5573L27.3679 32.4381L29.251 26.4287H31.5034Z",
    fill: "#9DD8FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4655_315439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 31.5632) scale(26 25.4368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "transparent",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#007CF9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005BB8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#003F80",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#002952",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "transparent",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4655_315439",
    x1: 22.3058,
    y1: 10.5191,
    x2: 22.3058,
    y2: 0.0141602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4655_315439",
    x1: 31.222,
    y1: -0.00534157,
    x2: 31.222,
    y2: -0.00534157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4655_315439",
    x1: 38.1952,
    y1: 52.0477,
    x2: 38.1952,
    y2: 9.77441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121ED6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4655_315439",
    x1: 35.8361,
    y1: 19.8774,
    x2: 35.8361,
    y2: 8.03336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4655_315439",
    x1: 48.9262,
    y1: 33.1448,
    x2: 48.9262,
    y2: 18.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4655_315439",
    x1: 46.3139,
    y1: 45.7703,
    x2: 46.3139,
    y2: 36.1689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4655_315439",
    x1: 15.1947,
    y1: 52.0477,
    x2: 15.1947,
    y2: 9.77441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121ED6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4655_315439",
    x1: 17.5862,
    y1: 19.8774,
    x2: 17.5862,
    y2: 8.03336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4655_315439",
    x1: 4.49735,
    y1: 33.1448,
    x2: 4.49735,
    y2: 18.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4655_315439",
    x1: 7.10108,
    y1: 45.7703,
    x2: 7.10108,
    y2: 36.1689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4655_315439",
    x1: 26.7449,
    y1: 51.2014,
    x2: 26.7449,
    y2: 13.1016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4655_315439",
    x1: 26.7295,
    y1: 30.9203,
    x2: 26.7295,
    y2: 11.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4655_315439",
    x1: 26.7446,
    y1: 48.0896,
    x2: 26.7446,
    y2: 16.2173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4655_315439",
    x1: 26.4867,
    y1: 53.3061,
    x2: 26.4867,
    y2: 46.9551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2C38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4655_315439",
    x1: 26.6126,
    y1: 52.8485,
    x2: 26.6126,
    y2: 47.6025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4655_315439",
    x1: 26.7306,
    y1: 17.1129,
    x2: 26.7306,
    y2: 12.0229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4655_315439",
    x1: 26.6442,
    y1: 9.01547,
    x2: 26.6442,
    y2: 1.27979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326CA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#282E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4655_315439",
    x1: 26.7324,
    y1: 8.30032,
    x2: 26.7324,
    y2: 1.86475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121ED6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_4655_315439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0154 33.2049) rotate(10.689) scale(2.30387 4.24398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00DFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00A5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#007280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#004952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00292E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_4655_315439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.93701 34.8932) rotate(-15.1112) scale(2.30215 4.24716)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00DFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00A5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#007280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#004952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00292E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_4655_315439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7667 48.2108) rotate(-48.3477) scale(2.27736 4.29339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00DFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00A5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#007280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#004952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00292E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondLeague);
export default __webpack_public_path__ + "static/media/diamond-league.473896af7d6259af35759554f961dcfb.svg";
export { ForwardRef as ReactComponent };